KMVP.quoteDetailPage = {
    isPageBlocked: function() {
        return $('.js-kmc-quote-detail-page').hasClass('form-blocked');
    },
    bindPrintPage: function() {
        $(document).on('click', '.js-kmc-quote-detail-page .js-print-quote-button', function() {
            KMVP.logRocketService.trackEvent('print_quote_button_clicked_d2');
            window.print();
        });
    },
    bindSubmitQuote: function() {
        $(document).on('click', '.js-kmc-quote-detail-page .js-submit-quote-button', function() {

            if (KMVP.quoteDetailPage.isPageBlocked()) {
                return;
            }

            KMVP.quoteDetailPage.blockPage();

            $.ajax({
                url: $(this).data('quoteSubmitUrl'),
                type: "POST",
                data: {
                    comment: $('.js-kmc-quote-detail-page .js-quote-comment').val()
                },
                success: function (data) {
                    KMVP.kmcQuoteCommon.showQuoteConfirmation(data);
                },
                complete: function () {
                    KMVP.quoteDetailPage.unblockPage();
                },
                error: function (xht, textStatus, ex) {
                    alert("Failed to process quote. Error details [" + xht + ", " + textStatus + ", " + ex + "]");
                }
            });
        });
    },
    blockPage: function() {
        $('.js-kmc-quote-detail-page').addClass('form-blocked');
        $('.js-kmc-quote-detail-page .submit-quote-button').showSpinner();
    },
    unblockPage: function() {
        $('.js-kmc-quote-detail-page').removeClass('form-blocked');
        $('.js-kmc-quote-detail-page .submit-quote-button').hideSpinner();
    }
};

$(document).ready(function () {
    KMVP.quoteDetailPage.bindSubmitQuote();
    KMVP.quoteDetailPage.bindPrintPage();
});
